module.exports = __webpack_public_path__ + "img/treatment-with-treatment-directory-icon.5de72552.svg";